<template>
	<div class='main-mybody' style="padding-top: 1rem;" id='homeqi'>
		<a-row>
			<a-col :span='11'>
				<a-form-model ref='ruleForm' :model="form" labelAlign='left' layout="inline" :rules='rules'
						hideRequiredMark>
						<div class='look_g'><div></div>假期類型</div>
						<a-form-model-item label="">
							<a-radio-group v-model="form.asktype" @change='asktypefn'>
								<div style="position: relative;">
									<a-radio :value="item.value*1" v-for='(item,ind) in yeararr' :key='ind+"vbs"'
										:style='{margin:ind +1 == yeararr.length?"0  0 0 13%":""}'
										:class='item.cla==1?"myauto":item.cla==2?"mayright":""'>
										{{item.text}}
									</a-radio>
									<a-input v-model="form.otherasktype" class='warp_width'
										:disabled='form.asktype  !== 0' placeholder='請輸入其他'
										style='width:6.5rem;' />
								</div>
							</a-radio-group>
						</a-form-model-item>
						<div class='main-wid' style="margin-top: 0;width: 100%;"></div>
						<div class='look_g'><div></div>假期時間</div>
						<a-form-model-item style="    width: 100%;">
							<!-- <div style="display: flex;align-items: center;">
								<div slot="label" v-html='"日期 :"' style="flex-shrink: 0;margin-right: 1%;"></div>
								<a-date-picker v-model="value1" @change="dateClick(1)"  placeholder=''/>
								<div style="display: inline-block;margin: 0 0.5rem;">
									一
								</div>
								<a-date-picker v-model="value2" @change="dateClick(2)" placeholder=''/>
							</div> -->
							<div style="display: flex;align-items: center;">
								<div slot="label" v-html='"日期 :"' style="flex-shrink: 0;margin-right: 1%;"></div>
								<a-range-picker v-model="value3" @change="dateClick(1)" :placeholder="['開始時間', '結束時間']" />
							</div>
							<div style="display: flex;align-items: center;margin-top: 5%;">
								<div slot="label" v-html='"時間 :"'  style="flex-shrink: 0;margin-right: 1%;"></div>
								<a-select v-model="form.begintime" @change="dateClick(3)" class='warp_width' >
									<a-select-option v-for="(item,inds) in Arr1" :key="inds+'a'" :value="item.value">
										{{item.text }}
									</a-select-option>
								</a-select>
								<div style="display: inline-block;margin: 0 0.5rem;">
									一
								</div>
								<a-select v-model="form.endtime" @change="dateClick(4)" class='warp_width'>
									<a-select-option v-for="(item,indv) in admintypeArrs" :key="indv+'as'"
										:value="item.value">{{item.text}}</a-select-option>
								</a-select>
							</div>
						</a-form-model-item>

						<!-- <div>
							<a-form-model-item prop='remark'>
								<div slot="label" v-html='"備&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;註"'
									style="display: inline-block;color: #000000;"></div>
								<a-input v-model="form.remark" class='warp_width' placeholder='請輸入備註'
								 style='width: 23rem;'/>
							</a-form-model-item>
						</div> -->
					</a-form-model>
			</a-col>
			<a-col :span='2'></a-col>
			<a-col :span='11'>
				<!-- <rl @child='handff' :stas='1' :listdate='backform' :asktype='form.asktype' :lihe='"3.84rem"'
			></rl> -->
				<div class='look_g'><div></div>假期匯總</div>
				<div>
					<div style="display: flex;">
						<div slot="label" v-html='"開始時間："' style="display: inline-block;color: #000000;"></div>
						<div>{{and_data}}</div>
					</div>
					<div style="display: flex;margin-top: 20px;">
						<div slot="label" v-html='"結束時間："' style="display: inline-block;color: #000000;"></div>
						<div>{{end_data}}</div>
					</div>
					<div style="display: flex;margin-top: 20px;">
						<div slot="label" v-html='"假期合計："' style="display: inline-block;color: #000000;"></div>
						<div>{{caltime}}</div>
					</div>
				</div>
				<div class='main-wid' style="margin:35px 0 1rem 0;width: 100%;"></div>
				<div class='look_g'><div></div>備註</div>
				<a-textarea :rows="4"  v-model="form.remark" class='warp_width' placeholder='請輸入備註' style="margin-bottom:20px" />
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import rl from './rlmate.vue'
	import App from '@/assets/app.js';

	export default {
		props: ['pared'],
		components: {
			rl
		},
		data() {
			return {
				visible: true,
				timeFlag: false,
				rules: {},
				value1:'',
				value2:'',
				value3:[],
				caltime:'',
				and_data:'',
				end_data:'',
				formview: {
					createtime: "",
					department: "",
					position: "",
					realname: "",
					sex: 0,
				},
				backform: {
					begindates: '',
					enddates: ''
				},
				form: {
					"type": 1, //類型 1 假期申請 2 外出 3加班
					"asktype": 1, // 1年假 2病假 3婚假 4產假 5陪產假 6喪假 7無薪休假 0其他
					"otherasktype": "", //  其他請假形式
					"remark": "",
					"begindate": "",
					enddate: '',
					"begintime": "",
					// "enddate": "2021-6-7",
					"endtime": "",
					day_hour: '',
					yearholiday_days: ''
				},
				yeararr: [{
					text: '年假',
					value: '1',
				}, {
					text: '病假',
					value: '2',
					cla: '1'
				}, {
					text: '婚假',
					value: '3',
					cla: '2'
				}, {
					text: '產假',
					value: '4',
				}, {
					text: '陪產假',
					value: '5',
					cla: '1'
				}, {
					text: '喪假',
					value: '6',
					cla: '2'
				}, {
					text: '無薪休假',
					value: '7',
				}, {
					text: '其他',
					value: '0',
					cla: '1'
				}, ],
				Arr1: [{
					text: '9:00',
					value: '9:00',

				}, {
					text: '14:00',
					value: '14:00',
				}],
				admintypeArrs: [{
					// 	text: '9:00',
					// 	value: '9:00',
					// }, {
					text: '13:00',
					value: '13:00',
					// }, {
					// 	text: '14:00',
					// 	value: '14:00',
				}, {
					text: '18:00',
					value: '18:00',
				}],
				jiejiari: [
					'2021-1-1',
					'2021-2-12',
					'2021-2-13',
					'2021-2-14',
					'2021-2-15',
					'2021-4-2',
					'2021-4-3',
					'2021-4-4',
					'2021-4-5',
					'2021-4-6',
					'2021-5-1',
					'2021-5-19',
					'2021-6-14',
					'2021-7-1',
					'2021-9-22',
					'2021-10-1',
					'2021-10-14',
					'2021-12-25',
					'2021-12-27',
				],
			}
		},
		// watch: {
		// 	form: {
		// 		deep: true,
		// 		handler(ev) {
		// 			this.datafn()
		// 		}
		// 	}
		// },
		mounted() {
			this.handimg()
		},
		methods: {

			asktypefn() {
				if (this.form.asktype !== 0) {
					this.form.otherasktype = ''
				}
				if (this.value3.length>0) {
					this.getHolidayCalculation(this.and_data,this.end_data)
				}
			},
			handimg(record) {
				this.$ajax({
					method: 'post',
					url: this.$api.getAttenceApplyInfo,
					data: {
						applyid: this.pared.applyid || '',
						token: this.$store.state.token,
						applytype:1
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.formview = res.data
						if (this.pared.applyid) {
							this.form = res.data
							this.value1 = res.data.begindate;
							this.value2 = res.data.enddate;
							this.value3 = [res.data.begindate,res.data.enddate];
							if (res.data.begindate && res.data.begintime) {
								this.and_data = res.data.begindate +' '+ res.data.begintime
							}
							if (res.data.enddate && res.data.endtime) {
								this.end_data = res.data.enddate +' '+ res.data.endtime
							}
							this.caltime = res.data.day_hour
							if (res.data.type == 1) {
								this.form.type = 2
							}
							this.form.num = Math.ceil(this.form.day_hour.split(' ')[0]);
							this.backform.begindates = this.form.begindate
							this.backform.enddates = this.form.enddate
						}
						// this.form.yearholiday_days = res.data.yearholiday_days
						setTimeout(() => {
							this.visible_bold = true;
						}, 100)
					} else {
						this.visible_bold = true
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			// datafn() {
			// 	if (this.form.num) {
			// 		if ((this.form.begintime == '9:00' || this.form.begintime == '09:00') && this.form.endtime ==
			// 			'18:00') {
			// 			this.form.day_hour = this.form.num + ' 天'
			// 		} else {
			// 			if ((this.form.begintime == '14:00') && (this.form.endtime == '13:00' || this.form.endtime ==
			// 					'14:00')) {
			// 				this.form.day_hour = this.form.num - 1 + ' 天'
			// 			} else {
			// 				this.form.day_hour = this.form.num - .5 + ' 天'
			// 			}
			// 		}
			// 		// if (this.form.day_hour) {
			// 		// 	if (this.form.day_hour.split(' ')[0] * 1 > this.form.yearholiday_days * 1) {
			// 		// 		// App.oTool.warningT('剩餘假期天數不足');
			// 		// 		this.form.fants = true
			// 		// 	} else {
			// 		// 		this.form.fants = false
			// 		// 	}
			// 		// }
			// 	}
			// },
			dateClick(val){
				if (this.value3.length>0) {
					if (this.form.begintime) {
						this.and_data = App.oDate.secsTime3(this.value3[0]._d) +' '+ this.form.begintime
					}
					if (this.form.endtime) {
						this.end_data = App.oDate.secsTime3(this.value3[1]._d) +' '+ this.form.endtime
					}
					this.form.begindate = App.oDate.secsTime3(this.value3[0]._d) 
					this.form.enddate = App.oDate.secsTime3(this.value3[1]._d)
					console.log(this.and_data,this.end_data);
					if (this.form.begindate == this.form.enddate) {
						this.timeFlag = true;
						if (this.form.begintime == '14:00') {
							this.form.endtime = '18:00'
							this.end_data = App.oDate.secsTime3(this.value3[1]._d) +' '+ this.form.endtime
							this.admintypeArrs = [{
								text: '18:00',
								value: '18:00',
							}]
						}else{
							this.admintypeArrs = [
								{
									text: '13:00',
									value: '13:00',
								},
								{
									text: '18:00',
									value: '18:00',
								}
							]

						}

					}else{
						console.log("不相等");
						this.admintypeArrs = [
							{
								text: '13:00',
								value: '13:00',
							},
							{
								text: '18:00',
								value: '18:00',
							}
						]
					}
					this.getHolidayCalculation(this.and_data,this.end_data)
				}
			},
			getHolidayCalculation(begintime,endtime){
				let yearholidayflag
				if (this.form.asktype == 1) {
					yearholidayflag = 1;
				}
				this.$ajax({
					method: 'post',
					url: this.$api.getHolidayCalculation,
					data: {
						begintime:begintime,
						endtime:endtime,
						yearholidayflag:yearholidayflag
					}
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						console.log(res);
						this.caltime = res.data.caltime
						this.form.day_hour = res.data.caltime
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			handff(val, num) {
				this.$set(this.form, 'num', num ? num : 0)
				this.form.begindate = ''
				this.form.enddate = ''
				if (val) {
					if (val.length > 1) {
						this.form.begindate = val[0]
						this.form.enddate = val[1]
					} else if (val.length == 1) {
						this.form.begindate = val[0]
						this.form.enddate = val[0]
					}
				}
			},
			handcal(ev) {
				// console.log(ev)
			},
			formatDate(ds) {
				var date = ds._d
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m;
				var d = date.getDate();
				d = d;
				return y + '-' + m + '-' + d;
			},
			disabledDate(val) {
				var time = val._d
				//time.getTime() < Date.now() || time.getTime() >Date.now() + 3 * 30 * 24 * 60 * 60 * 1000 ||
				var statenow = time.getDay() == 0 || time.getDay() == 6 || this.jiejiari.indexOf(time.getFullYear() + '-' +
					(time
						.getMonth() + 1) + '-' + time.getDate()) >= 0;
				return statenow;
			},
			backfn(gucode) {
				let str = ''
				this.Arr1.map(ev => {
					if (ev.value == this.form.exchange_code) {
						str = ev[gucode]
					}
				})
				return str
			},
			resetForm(val) { // 1儲存 2 提交
				if (this.form.asktype == 0) {
					if (!this.form.otherasktype) {
						App.oTool.warningT('請輸入其他假期');
						return
					}
				}
				if (!this.form.begindate) {
					App.oTool.warningT('請選擇休假時間');
					return
				}
				if (!this.form.enddate) {
					App.oTool.warningT('請選擇休假時間');
					return
				}
				if (this.caltime == '0 天') {
					App.oTool.warningT('請選擇有效假期時間');
					return
				}
				// if (this.form.day_hour.split(' ')[0] * 1 > this.form.yearholiday_days * 1) {
				// 	App.oTool.warningT('剩餘假期天數不足');
				// 	return
				// }
				this.form.issave = ''
				this.form.issave = val
				this.form.type = 1
				this.form.token = this.$store.state.token;
				// this.$refs[formName].resetFields();

				this.$ajax({
					method: 'post',
					url: this.$api.newApply,
					data: this.form
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						App.oTool.successT();
						this.$emit('child', 0)
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				})
			},
			// this.$emit('child', 0)
			handleOk1() {}
		}
	}
</script>

<style lang="scss">
	#homeqi {
		@media screen and (min-width:2200px){
			.ant-radio-inner::after{
				top: 2px;
			}
		}
		input::-webkit-input-placeholder {
			font-size: 0.75rem;
		}
		textarea::-webkit-textarea-placeholder {
			font-size: 0.75rem;
		}
		.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled) {
			background-color: red !important;
		}

		.ant-fullcalendar-today .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-current-cell .ant-fullcalendar-value {
			box-shadow: 0 0 0 1px red inset;
		}

		.ant-fullcalendar-selected-day .ant-fullcalendar-value,
		.ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value {
			background: red;
		}

		.ant-radio-group-small {
			display: none;
		}

		.ant-fullcalendar-header {
			.ant-fullcalendar-year-select {
				width: 5rem;
				display: inline-block;
			}

			.ant-fullcalendar-month-select {
				width: 5rem;
				display: inline-block;
			}
		}

		.myauto {
			margin: 0 13%;
		}

		.mayright {
			// margin-left: 1rem;
			// left: 2rem;
			// position: relative;
		}

		.titName {
			font-size: 0.75rem !important;
			color: #000;
		}

		.comname {
			font-size: 0.75rem !important;
		}

		.ant-modal {
			top: 9vh;
		}

		.warp_min {
			vertical-align: top;
			width: 64%;
			height: 3rem;
			line-height: 3rem;
			font-size: 0.75rem;
			padding: .7rem 0;
			display: inline-block;
		}

		.warp_titlis {
			margin-right: .1rem;
			color: #000;
			width: 34.5%;
		}

		.ant-modal-content {
			border-radius: 10px;
		}

		.ant-form-item {
			margin-bottom: .1rem;
		}

		.ant-form-item label {
			font-size: 0.75rem !important;
			width: 4rem;
			margin-bottom: 20px;
		}

		.ant-input {
			font-size: 0.75rem !important;
		}

		.ant-select-selection-selected-value {
			font-size: 0.75rem !important;
		}

		.ant-form-item-children {
			font-size: 0.75rem !important;
		}

		.warp_btn {
			cursor: pointer;
			width: 1.5rem;
			color: #fff;
			display: inline-block;
			margin: 0 .1rem;
			height: 1.5rem;
			line-height: 1.5rem;
			text-align: center;
			border-radius: 10px;
		}

		.ant-modal-body {
			padding: 0;
			padding-top: 2.5rem;
		}

		.btn1 {
			cursor: pointer;
			width: 5rem;
			height: 2rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			margin: 0 3.5rem;
		}

		.btnfour {
			cursor: pointer;
			width: 3.5rem;
			height: 1.5rem;
			font-size: .75rem;
			color: #fff;
			border: 0;
			border-radius: 20px;
			margin-left: 0.8rem;
			background-color: #a6b7c4;
		}

		.btnx {
			background-color: #0c8b97;
		}

		.btn2 {
			background-color: #f48d28;
		}

		.pos_ste {
			position: relative;
			// width: 2rem;
			font-size: .6rem;
			background-color: #ee7171;
			top: -3rem;
			left: 1rem;
		}
	}
</style>
